import type { TableProps } from "antd";
import { Col, Row, Table, Tag, Typography } from "antd";
import React from "react";
import { formatDate } from "../../../helpers/date";
import "./index.css";

const SMSBotRecentActivityTable: React.FC<SMSBotRecentActivityTableProp> = ({
  messages,
}) => {
  const formatMessageStatus = (status: string) => {
    return status
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const getStatusColor = (status: string) => {
    return status === "MESSAGE_SENT" ? "success" : "error";
  };

  const columns: TableProps<ITransactionMessage>["columns"] = [
    {
      title: "Status",
      dataIndex: "messageStatus",
      key: "messageStatus",
      render: (status: string) => (
        <Tag color={getStatusColor(status)}>{formatMessageStatus(status)}</Tag>
      ),
    },
    {
      title: "Acknowledged At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (text: string) => <span>{formatDate(new Date(text))}</span>,
    },

    {
      title: "messageText",
      render: (row) => (
        <Typography
          style={{ display: "flex", alignContent: "center", gap: "10px" }}
        >
          {row.messageText}
        </Typography>
      ),
    },
  ];

  return (
    <>
      <div className="netwala-users-table-container">
        <Row>
          <Col span={24}>
            <Typography className="netwala-user-tables-heading">
              SMS Bot Recent Activity
            </Typography>
            <Table
              className="netwala-users-table striped-table"
              columns={columns}
              dataSource={messages}
              pagination={false}
              scroll={{ x: "max-content" }}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};
export default SMSBotRecentActivityTable;
